import type { ExtendedRouteObject } from "./types";

/** Rotas de campo/obras — adicionar conforme implementação */
export const fieldRoutes: ExtendedRouteObject[] = [];
